// Service Worker Registration
export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      // Unregister old service workers first to ensure clean state
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.update(); // Force check for updates
        });
      });

      navigator.serviceWorker
        .register('/sw.js', { updateViaCache: 'none' }) // Don't use HTTP cache for SW
        .then((registration) => {
          console.log('SW registered: ', registration.scope);
          
          // Force update check on every page load
          registration.update();
          
          // Check for updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            console.log('New SW installing...');
            
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // New content available
                  console.log('New content available, refreshing...');
                  // Auto-refresh for seamless update
                  newWorker.postMessage({ type: 'SKIP_WAITING' });
                  
                  // Show brief notification then reload
                  const shouldRefresh = window.confirm('New version available! Click OK to refresh.');
                  if (shouldRefresh) {
                    window.location.reload();
                  }
                } else {
                  // First install
                  console.log('Content cached for offline use.');
                }
              }
            });
          });
        })
        .catch((error) => {
          console.log('SW registration failed: ', error);
        });
    });

    // Listen for controller change and reload
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      console.log('Controller changed, reloading...');
      window.location.reload();
    });
  }
};

export const unregisterServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
    // Also clear caches
    caches.keys().then((names) => {
      names.forEach((name) => caches.delete(name));
    });
  }
};

// Force clear all caches - call this to fix stuck deployments
export const clearAllCaches = async () => {
  if ('caches' in window) {
    const names = await caches.keys();
    await Promise.all(names.map((name) => caches.delete(name)));
    console.log('All caches cleared');
  }
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((r) => r.unregister()));
    console.log('All service workers unregistered');
  }
  window.location.reload();
};
